import Vue from 'vue'
import VueRouter from 'vue-router'
import HotspotsEditor from '@/editor/hotspots.vue' //last version

Vue.use(VueRouter)

const routes = [
  {
    path: '/editor',
    name: 'HotspotsEditor',
    component: HotspotsEditor
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
